export const ScoringWlTexts = {
  description: ['Ваш кредитный', 'рейтинг'],
};
